import React, { useEffect, useRef, useState } from 'react'
import './leaderboard.styles.scss';
import {
  getFilteredDataFromRtDb,
  getLeaderboardChangeDataFromDb,
  getLeaderboardDataFromRtDb,
  getLiveDataFromDb,
  getPlayersFromPlayerDocs,
  getRegsFromDb,
  getUniqueDocumentFromDb
} from '@/utils/getDataFromDb';
import { useParams } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import LeaderboardItem from './leaderboard-item.component';
import { useSelector } from 'react-redux';
import { off } from 'firebase/database';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import LeaderboardSettings from './leaderboard-settings.component';
import { format } from 'date-fns';
import { version } from '@/changelog-version';

const LeaderboardPage = ({
  playerView,
  playerData
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const { livePath } = useParams();
  const [liveData, setLiveData] = useState(null);
  const [leaderData, setLeaderData] = useState(null);
  const [teamMembers, setTeamMembers] = useState(null);
  const [levels, setLevels] = useState(null);
  const [gameData, setGameData] = useState(null);
  const [dataToDisplay, setDataToDisplay] = useState({});
  const [adminAccess, setAdminAccess] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [displayCount, setDisplayCount] = useState(0);
  const [alertMessage, setAlertMessage] = useState(false);
  const levelRef = useRef();
  const leaderRef = useRef({});
  let liveListener;
  let gameListener;
  let leaderboardListener;
  let levelListener;
  let badgeListener;
  let changeListener;
  let regsListener;

  useEffect(() => {

    return () => {
      if (liveListener) liveListener();
      if (gameListener) gameListener();
      if (leaderboardListener) off(leaderboardListener);
      if (levelListener) levelListener();
      if (badgeListener) badgeListener();
      if (changeListener) off(changeListener);
      if (regsListener) regsListener();
    }
  }, [])

  useEffect(() => {
    if (!livePath) return;
    console.log(livePath);

    getLiveData();
  }, [livePath])

  useEffect(() => {
    if (!leaderData || !liveData) return;
    checkAdminAccess();
    if (liveData.data === 'change') {
      getChangeData();
    } else {
      compileLeaderData();
    }
  }, [leaderData, liveData, userProfile, teamMembers])

  function checkAdminAccess() {
    if (!userProfile) return;
    getRegsFromDb({
      'gameId': liveData.gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      if (
        data.roles[userProfile.appId] &&
        (
          data.roles[userProfile.appId].includes('owner') ||
          data.roles[userProfile.appId].includes('manager')
        )
      ) {
        setAdminAccess(true);
      }
    }
    function handleListener(unsub) {
      regsListener = unsub;
    }
  }

  function getChangeData() {
    // console.log('getting change data')
    getLeaderboardChangeDataFromDb({
      'gameId': liveData.gameId,
      'leaderboardId': liveData.id,
      'callback': callback,
      'handleListener': handleListener,
    })

    function callback(changeData) {
      compileLeaderData(changeData);
    }
    function handleListener(unsub) {
      changeListener = unsub;
    }
  }

  async function compileLeaderData(changeData) {
    let leaderObj = {};
    if (liveData.indOrTeams === 'individuals') {
      const leaderArr = Object.values(leaderData).filter(l => l.status === 'active' && !l.team);
      for (let l of leaderArr) {
        let obj = {
          'playerId': l.playerId,
          'name':
            liveData.nameDisplay === 'full'
              ? `${l.fName} ${l.lName}`
              : liveData.nameDisplay === 'display'
                ? l.displayName
                : l.secretName,
          'icon': l.icon,
          'gradient': l.gradient,
          'badges': l.badges,
          'dataValue': l[liveData.data] ?? 0,
        }
        leaderObj[obj.playerId] = obj;
      }
    } else if (liveData.indOrTeams === 'teams') {
      const teamArr = Object.values(leaderData).filter(l => l.status === 'active' && l.team);
      for (let t of teamArr) {
        let tempData = 0;
        if (teamMembers) {
        const members = teamMembers[t.playerId]?.members ?? [];
          // console.log(members);
          for (let m of members) {
            const playerData = leaderData[m];
            if (!playerData) continue;
            tempData += playerData[liveData.data] ?? 0;
            t.animate = playerData.animate ? true : false;
          }
        }
        let obj = {
          'playerId': t.playerId,
          'name': t.displayName,
          'icon': t.icon,
          'gradient': t.gradient,
          'badges': t.badges,
          'dataValue': tempData,
        }
        leaderObj[obj.playerId] = obj;
      }
    }
    for (let l of Object.values(leaderObj)) {
      const newObj = { ...l };
      if (changeData) {
        if (changeData[l.playerId]) {
          let playerChange = changeData[l.playerId];
          let baseline = 0;
          let newData = 0;
          let change = 0;
          let pct = 0;
          if (playerChange.baseline) {
            baseline = playerChange.baseline;
          }
          if (playerChange.newData) {
            newData = playerChange.newData;
          } else {
            newData = baseline;
          }
          change = newData - baseline;
          pct = 0;
          if (baseline !== 0 && change !== 0) {
            pct = (change / baseline) * 100
          }
          if (liveData.opt_changeDisplay === 'actual') {
            newObj.data = change;
          } else {
            newObj.data = pct;
            newObj.actual = change;
          }
        } else {
          newObj.data = 0;
          newObj.actual = 0;
        }
      } else {
        newObj.data = l.dataValue ?? 0;
      }

      if (
        dataToDisplay[newObj.playerId] &&
        dataToDisplay[newObj.playerId].data !== newObj.data
      ) {
        newObj.animate = true;
      }
      leaderObj[newObj.playerId] = newObj
    }
    setDataToDisplay({...leaderObj});
  }


  function getLiveData() {
    // console.log('getting live data')
    getLiveDataFromDb({
      'path': livePath,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      if (data.status !== 'active') {
        setAlertMessage('This leaderboard is not active.');
        return;
      }
      setLiveData(data);
      console.log(data);
      getLeaderboardData(data);
      getGameData(data.gameId, data.name);
      if (data.levels && data.levels === true) {
        console.log(data.levels);
        getLevels(data.gameId);
      }
      setDisplayCount(data.count);
      // if (data.badges) {
      //     getBadges(data.gameId);
      // }
    }
    function handleListener(unsub) {
      liveListener = unsub;
    }
  }

  function getGameData(gameId, leaderboardName) {
    getUniqueDocumentFromDb({
      'collection': 'games',
      'docId': gameId,
      'callback': callback,
      'handleListener': handleListener,
    })
    function callback(data) {
      setGameData(data);
      changeDocumentTitle(`Gamably | ${leaderboardName}`, data.icon);
    }
    function handleListener(unsub) {
      gameListener = unsub;
    }
  }

  function getLeaderboardData(leaderboardSettings) {
    // console.log('getting leaderboard data')
    // console.log(leaderboardSettings);
    if (leaderboardSettings.indOrTeams === 'individuals') {
      getLeaderboardDataFromRtDb({
        'gameId': leaderboardSettings.gameId,
        'limit': leaderboardSettings.count ?? 20,
        'dataField': leaderboardSettings.data,
        'callback': callback,
        'handleListener': handleListener
      })
    } else {
      getPlayersFromPlayerDocs({
        'gameId': leaderboardSettings.gameId,
        'callback': callback,
        'handleListener': handleListener
      })
      getTeamMembers(leaderboardSettings.gameId);
    }
    function callback(data) {
      console.log(data);
      for (let l of Object.values(data)) {
        if (Object.keys(data).length === 1) {
          l.animate = true;
        }
        if (l.status === 'active') {
          leaderRef.current[l.playerId] = l;
        }
      }
      setLeaderData({...leaderRef.current});
    }
    function handleListener(unsub) {
      leaderboardListener = unsub;
    }
  }

  function getTeamMembers(gameId) {
    getUniqueDocumentFromDb({
      'collection': `games/${gameId}/teamMembers`,
      'docId': `${gameId}-teamMembers`,
      'once': true,
      'callback': callback,
    })
    function callback(data) {
      // console.log(data);
      setTeamMembers(data);
    }
  }

  function getLevels(gameId) {
    getFilteredDataFromRtDb({
      'path': `games/${gameId}/gameElementShortList`,
      'key': 'type',
      'value': 'level',
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      levelRef.current = { ...levelRef.current, ...{ [data.id]: data } }
      setLevels(levelRef.current);
    }
    function handleListener(unsub) {
      levelListener = unsub;
    }
  }

  function showFullLeaderboard() {
    // console.log('full')
    setDisplayCount(Object.values(dataToDisplay).length);
    setAlertMessage('Full Leaderboard is now displayed.');
  }
  return (
    <div className='leaderboard-page-container'>
      {
        (gameData)
          ?
          <div className={`leaderboard-page-content ${screenSize}`} style={
            (gameData.bg.type === 'gradient')
              ?
              { 'background': `linear-gradient(to bottom, ${gameData.bg.hexTop}, ${gameData.bg.hexBottom})` }
              :
              { 'backgroundImage': `url("${gameData.bg.url}")` }
          }>
            {
              (adminAccess) &&
              <div className='menu-button'>
                <button
                  className={`g-button ${screenSize === 'mobile' || screenSize === 'tablet' ? 'small-btn' : 'med-btn'}`}
                  onClick={() => setShowSettingsModal(true)}>
                  <FontAwesomeIcon
                    icon={faGear}
                    size="xl" />
                </button>
              </div>
            }
            <div className='leaderboard-header content'>
              <div className='leaderboard-head-image'>
                <ImageContainer src={gameData.header} alt='game primary icon' />
              </div>
              {
                (liveData) &&
                <div className='leaderboard-head-title'>
                  {liveData.name}
                </div>
              }
            </div>
            {/* <div className="g-space-0-5"></div> */}
            {
              (liveData && liveData.data === 'change') &&
              <div>
                {
                  (liveData.opt_baselineSetDate)
                    ? <div className='meta'>Baseline set {format(new Date(liveData.opt_baselineSetDate), "Pp")}</div>
                    : <div className='meta'>No baseline has been set to measure change.</div>
                }
                {
                  (liveData.opt_dateEnd)
                    ? <div className='meta'>Will stop tracking on {format(new Date(liveData.opt_dateEnd), "Pp")}</div>
                    : null
                }
              </div>
            }
            <div className='g-space-0-5'></div>
            {
              (Object.values(dataToDisplay).length > 0 && liveData)
                ?
                <div className='leaderboard-content content'>
                  {
                    Object.values(dataToDisplay)
                      .sort((a, b) => a.data < b.data ? 1 : -1)
                      .map((l, index) => {
                        if (l.data < 0) console.log(l.data);
                        if (index + 1 > displayCount) return;
                        return (
                          <div key={l.playerId}>
                            <LeaderboardItem
                              leader={l}
                              index={index}
                              liveData={liveData}
                              levels={levels}
                              playerView={playerView} />
                          </div>
                        )
                      })
                  }
                  {
                    (
                      playerView &&
                      playerData &&
                      dataToDisplay[playerData.playerId] &&
                      Object.keys(dataToDisplay).length > displayCount &&
                      Object.values(dataToDisplay).sort((a, b) => a.data < b.data ? 1 : -1).findIndex(l => l.playerId === playerData.playerId) >= displayCount
                    ) &&
                    <>
                      <h2>...</h2>
                      <LeaderboardItem
                        leader={dataToDisplay[playerData.playerId]}
                        index={Object.values(dataToDisplay).sort((a, b) => a.data < b.data ? 1 : -1).findIndex(l => l.playerId === playerData.playerId)}
                        liveData={liveData}
                        levels={levels}
                        playerView={playerView} />
                    </>
                  }
                  <div className='meta center-col'>{version}</div>
                </div>
                :
                <div className='center'><h3>Loading Players...</h3></div>
            }
          </div>
          :
          <div className='center'><h1>Loading Game Data...</h1></div>
      }
      <Modal
        show={showSettingsModal}
        cancel={() => setShowSettingsModal(false)}
        closeButton={true}
        text='Leaderboard Settings' >
        {
          (liveData) &&
          <div>
            <LeaderboardSettings
              liveData={liveData}
              leaderData={dataToDisplay}
              showFullLeaderboard={showFullLeaderboard} />
            <hr />
            <div className='buttons'>
              <button
                className='g-button'
                onClick={() => setShowSettingsModal(false)}>
                Done
              </button>
            </div>
          </div>
        }
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
    </div>
  )
}

export default LeaderboardPage